import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-601f02e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "production-template" }
const _hoisted_2 = { class: "pt-header bs-bb" }
const _hoisted_3 = { class: "pt-name" }
const _hoisted_4 = { class: "pt-profile" }
const _hoisted_5 = { class: "pt-buttons" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pt-btn-text" }, " 立即体验 ", -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pt-btn-text" }, " 视频介绍 ", -1))
const _hoisted_10 = { class: "pt-content" }
const _hoisted_11 = { class: "row-left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "solid-line" }, null, -1))
const _hoisted_13 = { class: "row-right" }
const _hoisted_14 = { class: "product-feature" }
const _hoisted_15 = { class: "product-feature-title" }
const _hoisted_16 = { class: "product-feature-desc" }
const _hoisted_17 = {
  class: "pt-content-row",
  bottom: ""
}
const _hoisted_18 = {
  class: "row-left",
  large: ""
}
const _hoisted_19 = { class: "ps-text" }
const _hoisted_20 = { class: "row-right position-relative" }
const _hoisted_21 = { class: "rr-wrapper" }
const _hoisted_22 = { class: "customer-service gray" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_ReactScrollImage = _resolveComponent("ReactScrollImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.introduce.name), 1),
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.introduce.profile), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "pt-btn",
          href: _ctx.introduce.buttons.experience,
          target: "_blank"
        }, [
          _hoisted_7,
          _createVNode(_component_SvgIcon, {
            class: "pt-btn-arrow",
            name: "arrow"
          })
        ], 8, _hoisted_6),
        (_ctx.introduce.buttons.videoIntroduce)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "pt-btn",
              href: _ctx.introduce.buttons.videoIntroduce,
              target: "_blank"
            }, [
              _hoisted_9,
              _createVNode(_component_SvgIcon, {
                class: "pt-btn-arrow",
                name: "arrow"
              })
            ], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.introduce.features, (item, index1) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "pt-content-row",
          ref_for: true,
          ref: _ctx.getContentRowRef,
          key: index1
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["left-svg-wrapper", {
                 even:(index1 + 1) % 2 == 0
               }])
            }, [
              _createVNode(_component_SvgIcon, {
                width: "43px",
                height: "43px",
                name: item.svgIconName
              }, null, 8, ["name"]),
              _hoisted_12
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(item.feature.title), 1),
              _createElementVNode("ul", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.feature.desc, (snippet, index2) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "feature-desc-snippet",
                    key: index2
                  }, _toDisplayString(snippet), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_ReactScrollImage, {
            widthOffset: 100,
            mode: 'translateX',
            height: '100%',
            src: require('@/assets/images/bg-6.jpg')
          }, null, 8, ["src"]),
          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.introduce.psText), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("img", {
                  class: "customer-service-qrcode",
                  src: _ctx.serverData.qrCodeSrc
                }, null, 8, _hoisted_23),
                (_ctx.serverData.wechatUserName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, "微信：" + _toDisplayString(_ctx.serverData.wechatUserName), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, "邮箱：" + _toDisplayString(_ctx.serverData.email), 1),
                _createElementVNode("p", null, "电话：" + _toDisplayString(_ctx.serverData.phoneNumber), 1)
              ])
            ], true)
          ])
        ])
      ])
    ])
  ]))
}